import { render, staticRenderFns } from "./deviceWorkUndeal.vue?vue&type=template&id=16ff2c96&scoped=true&"
import script from "./deviceWorkUndeal.vue?vue&type=script&lang=js&"
export * from "./deviceWorkUndeal.vue?vue&type=script&lang=js&"
import style0 from "./deviceWorkUndeal.vue?vue&type=style&index=0&id=16ff2c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff2c96",
  null
  
)

export default component.exports